import db from "@/database";

export const findAll = () => db.tumoralPhenomenon.toArray();
